import MixedMedia from '@klv/molecules/mixed-media';
import VideoModalTrigger from '@klv/molecules/video-modal-trigger';
import { generateClassName } from '@klv/shared/utils/functions';

import { hasMixedMedia } from '../utils';
import * as styles from './styles/twoColumnMedia.module.scss';


import type { ITwoColumnMediaProps, TMediaAlignment } from '../types';

export const TwoColumnMedia = ({
  mixedMedia,
  useVideoModal = false,
  videoModalContent,
  mediaAlignment,
  MediaCustomContent,
}: ITwoColumnMediaProps) => {
  if (MediaCustomContent) {
    return <>{MediaCustomContent}</>;
  }

  return (
    <div className={generateClassName([styles.gridMedia, styles[mediaAlignment as TMediaAlignment]])}>
      {mixedMedia && hasMixedMedia(mixedMedia) && !useVideoModal && (
        <MixedMedia data-chromatic="ignore" mixedMedia={mixedMedia} />
      )}
      {useVideoModal && videoModalContent?.image?.sourceUrl && videoModalContent?.videoUrl && (
        <VideoModalTrigger 
          videoDuration={videoModalContent.videoDuration} 
          modalHeadline={videoModalContent.videoHeadline} 
          videoPlayButtonColor={videoModalContent.videoPlayButtonColor}
          videoOverlayTitle={videoModalContent.videoOverlayTitle}
          videoUrl={videoModalContent.videoUrl}
        >
          <img
            alt={videoModalContent.image.altText || ''}
            className={styles.videoThumbnail}
            sizes="(max-width: 767px) 100vw, 50vw"
            src={videoModalContent.image.sourceUrl}
            srcSet={videoModalContent.image.srcSet}
            data-chromatic="ignore"
            loading="lazy"
          />
        </VideoModalTrigger>
      )}
    </div>
  );
}; 
